module.exports = __webpack_public_path__ + "static/media/logo.a87a4594.png";